export default __webpack_public_path__ + "static/201-e852865267178a4c588ccf1c1016b2cd.jpg";